export default function LoadingRegion({ label, children, className = '' }) {
  return (
    <section
      aria-busy="true"
      aria-labelledby="loading-region-status"
      className={className}
    >
      <p id="loading-region-status" role="status" aria-live="polite" className="sr-only">
        {label}
      </p>
      {children}
    </section>
  );
}
